import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import ProjectsGrid from '../components/ProjectsGrid';
import { t } from '../i18n';

// Utility to get API base URL depending on environment
const getApiBaseUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }
  // Use relative URL for production
  return '';
};


const ObjectPage = () => {
  const { id } = useParams(); // Actually the slug
  const [projects, setProjects] = useState([]);
  const [objectName, setObjectName] = useState('');
  const navigate = useNavigate();

  // If slug is missing or 'undefined', redirect to no-results
  useEffect(() => {
    if (!id || id === 'undefined') {
      navigate('/no-results');
    }
  }, [id, navigate]);

  useEffect(() => {
    if (!id || id === 'undefined') return;
    // Fetch object info by slug
    fetch(`${getApiBaseUrl()}/api/objects`)
      .then((response) => response.json())
      .then((objects) => {
        // Find object by slug
        const object = objects.find(obj => slugify(obj.name) === id);
        if (!object) {
          navigate('/no-results');
          return;
        }
        setObjectName(object.name);
        // Fetch projects for this object
        fetch(`${getApiBaseUrl()}/api/objects/${object.id}/projects`)
          .then((response) => response.json())
          .then((data) => {
            setProjects(data);
          })
          .catch((error) => {
            setProjects([]);
            console.error('Error fetching projects:', error);
          });
      })
      .catch((error) => {
        navigate('/no-results');
        console.error('Error fetching object:', error);
      });
  }, [id, navigate]);


  // Utility to create a slug from a string
  function slugify(text) {
    return text
      .toString()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .toLowerCase();
  }

  const handleProjectClick = (slug) => {
    // Always navigate using slug-only
    if (!slug || slug === 'undefined') {
      navigate('/no-results');
      return;
    }
    navigate(`/project/${slug}`);
  };

  return (
    <div style={styles.page}>
      <Helmet>
        <title>
          {objectName
            ? `Que faire avec un(e) ${objectName.toLowerCase()} cassé(e) : des idées DIY faciles et utiles`
            : 'Que faire avec un objet cassé : des idées DIY faciles et utiles'}
        </title>
        <meta
          name="description"
          content={
            objectName
              ? `Découvrez des idées simples pour recycler un(e) ${objectName.toLowerCase()} cassé(e) : déco, rangement, bricolage. Tutoriels + matériel nécessaire.`
              : 'Découvrez des idées simples pour recycler des objets cassés du quotidien : déco, rangement, bricolage. Tutoriels + matériel nécessaire.'
          }
        />
        <link rel="canonical" href={`https://0123456789.fr/objets/${id}`} />
      </Helmet>
      <h1 style={styles.title}>
        {objectName ? `Que faire avec un(e) ${objectName.toLowerCase()} cassé(e) : idées DIY faciles et utiles` : ''}
      </h1>
      <div style={styles.projectsSection}>
        {projects.length > 0 ? (
          <>
            <ProjectsGrid projects={projects} onProjectClick={handleProjectClick} />
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 36 }}>
              <button
                style={{
                  padding: '12px 28px',
                  fontSize: '18px',
                  backgroundColor: 'var(--green-eucalyptus, #2ecc40)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 600,
                  boxShadow: '0 2px 8px rgba(46,204,64,0.08)'
                }}
                onClick={() => navigate('/create-project')}
              >
                Partager ma création
              </button>
            </div>
          </>
        ) : (
          <p>{t('noProjectForObject') || 'Pas encore de projet basé sur cet objet.'}</p>
        )}
      </div>
    </div>
  );
};

const styles = {
  page: { position: 'relative', textAlign: 'center' },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' },
  projectsSection: {
    margin: '0 auto',
    marginTop: '60px',
    padding: '0 20px',
    maxWidth: '1500px',
  },
};

export default ObjectPage;